import React, {useEffect, useRef, useState} from "react";
import MobPressable from "./MobPressable";
import {MOBCOLORS} from "../../configs/AppConfig";
import {DynamicIcon} from "lucide-react/dynamic";


export function MobTabs({index,onChange,options,icons,fullWidth,style,colors,defaultColor,bordered})
{

    const containerRef = useRef(null);
    const tabRefs = useRef([]);

    const handleSelectTab = () => {
        const tab = tabRefs.current[index];
        tab?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center',
        });
    };

    useEffect(()=>{
        handleSelectTab()
    },[index])


    return(
        <div ref={containerRef} style={{display:"flex",alignItems:"center",gap:10,width:"100%",height:50,border:"0px solid red",overflowX:"auto",scrollbarWidth: 'none',msOverflowStyle: 'none',WebkitOverflowScrolling: 'touch',...style}} >
            {options.map((opt,i) => {
                const isSelected=i===index;

                let icon=null
                let color=MOBCOLORS["blue"];

                if(defaultColor && MOBCOLORS[defaultColor]){
                    color=MOBCOLORS[defaultColor];
                }

                if(Array.isArray(colors) && colors[i]){
                    color=MOBCOLORS[colors[i]];
                }

                if(Array.isArray(icons) && icons[i]){
                    icon=icons[i]
                }

                return (
                    <div key={opt} ref={(el) => (tabRefs.current[i] = el)} style={{display:"flex",flex:fullWidth?1:undefined,backgroundColor:!isSelected?"transparent":color.backgroundColor,border:bordered?("2px solid "+color.backgroundColor):"none",borderRadius:10,transitionDuration:"0.5s"}}>
                        <MobPressable
                            fastClick
                            style={{padding:"5px 15px",display:"flex",alignItems:"center",justifyContent:"center",flex:fullWidth?1:undefined,gap:5}}
                            onClick={()=>{
                                if(!isSelected && onChange){
                                    onChange(i)
                                }
                            }}
                        >
                            {icon &&(
                                <DynamicIcon name={icon} color={isSelected?color.color:"#4A6568"} size={15} style={{display:"flex",justifyContent:"center",alignItems:"center"}} />
                            )}
                            <span style={{color:isSelected?color.color:"#4A6568",opacity:isSelected?1:0.8,fontSize:15,textWrap:"nowrap"}}>{opt}</span>
                        </MobPressable>
                    </div>
                )
            })}
        </div>
    )
}
